"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledList = require("./StyledList");
var _excluded = ["className", "bordered", "dataSource", "size", "zebra", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ListItem(_ref) {
  var children = _ref.children,
    className = _ref.className,
    size = _ref.size;
  return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/_react.default.createElement(_StyledList.StyledListItem, {
      className: className,
      $size: size,
      theme: theme
    }, children);
  });
}
ListItem.propTypes = {
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  className: _propTypes.default.string
};
ListItem.defaultProps = {
  size: 'medium',
  className: ''
};
function ListTitle(_ref2) {
  var children = _ref2.children,
    className = _ref2.className;
  return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/_react.default.createElement(_StyledList.StyledListTitle, {
      className: className,
      theme: theme
    }, children);
  });
}
ListTitle.propTypes = {
  className: _propTypes.default.string
};
ListTitle.defaultProps = {
  className: ''
};
var List = exports.default = /*#__PURE__*/function (_Component) {
  function List() {
    (0, _classCallCheck2.default)(this, List);
    return _callSuper(this, List, arguments);
  }
  (0, _inherits2.default)(List, _Component);
  return (0, _createClass2.default)(List, [{
    key: "renderItems",
    value: function renderItems(theme) {
      var _this = this;
      if (this.props.renderItem) {
        return this.props.dataSource.map(function (item) {
          return _this.props.renderItem(item);
        });
      } else {
        return this.props.dataSource.map(function (item, index) {
          return /*#__PURE__*/_react.default.createElement(ListItem, {
            key: index,
            size: _this.props.size,
            theme: theme
          }, item);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        bordered = _this$props.bordered,
        dataSource = _this$props.dataSource,
        size = _this$props.size,
        zebra = _this$props.zebra,
        children = _this$props.children,
        rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(_StyledList.StyledList, (0, _extends2.default)({
          $bordered: bordered,
          $zebra: zebra,
          className: className,
          theme: theme
        }, rest), children && children, !children && dataSource && dataSource.length > 0 && _this2.renderItems());
      });
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(List, "Item", ListItem);
(0, _defineProperty2.default)(List, "Title", ListTitle);
List.propTypes = {
  bordered: _propTypes.default.bool,
  zebra: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  className: _propTypes.default.string,
  renderItem: _propTypes.default.func
  // loading: PropTypes.bool,
  // header: PropTypes.oneOfType([
  //   PropTypes.node,
  //   PropTypes.element,
  //   PropTypes.string,
  // ]),
  // footer: PropTypes.oneOfType([
  //   PropTypes.node,
  //   PropTypes.element,
  //   PropTypes.string,
  // ]),
};
List.defaultProps = {
  bordered: true,
  zebra: false,
  size: 'medium',
  className: ''
  // loading: false,
};
List.displayName = 'List';